import styled from 'styled-components';

interface Props {
    openModal: boolean
    width?: string;
}

export const ContainerOverlay = styled.div<Props>`
  background: rgba(0, 0, 0, 0.5);
  opacity: 1;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: ${props => props.openModal ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  z-index: 99999;
`;

export const Container = styled.div<Props>`
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-x: auto;
    max-height: 100vh;
    background: ${(props: any) => props.theme.colors.white};
    padding: 24px;
    width: ${props => props.width ? props.width : '400px'};      
    
    scrollbar-width: thin;
    scrollbar-color: ${(props: any) => props.theme.colors.interfaceGray300} ${(props: any) => props.theme.colors.background};
    &::-webkit-scrollbar {
      width: 12px;
      background: ${(props: any) => props.theme.colors.interfaceText200};
      border-radius: 12px;
    }
    &::-webkit-scrollbar-thumb {
      background: ${(props: any) => props.theme.colors.primaryBlue100};
      border-radius: 12px;
    }
`;
